export default __webpack_public_path__ + "static/media/sterilization-center.ecb7a272.png";